"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslatedClaims = void 0;
const __1 = require("..");
const types_1 = require("../types");
const ptBR = {
    [types_1.UsersClaims.OFFICE_CREDITORS_VIEW]: {
        title: 'Ver resultado de todos os usuários',
        description: 'Permite a visualização de todos os usuários na empresa',
    },
    [types_1.UsersClaims.CUSTOMIZED_TABLE]: {
        title: 'Tabela personalizada na página inicial',
        description: 'Mostra uma tabela personalizada na página inicial no lugar da tabela padrão',
    },
    [types_1.UsersClaims.TEAM_CREDITORS_VIEW]: {
        title: 'Ver usuários do time',
        description: 'Permite a visualização de usuários dos próprios times',
    },
    [types_1.UsersClaims.CLOSURE_UNFINISHED_VIEW]: {
        title: 'Visualizar fechamentos inacabados',
        description: 'Permite visualizar os fechamentos inacabados',
    },
    [types_1.UsersClaims.CLOSURE_UPDATE]: {
        title: 'Atualizar fechamentos',
        description: 'Permite atualizar/visualizar fechamentos',
    },
    [types_1.UsersClaims.USER_CREATE]: {
        title: 'Criar usuários',
        description: 'Permite a criação de usuários',
    },
    [types_1.UsersClaims.PAYROLL_VIEW]: {
        title: 'Visualizar folha de pagamento',
        description: 'Permite a visualização da folha de pagamento',
    },
    [types_1.UsersClaims.PAYSLIP_VIEW]: {
        title: 'Visualizar resumo de valores repassados/recebidos',
        description: 'Permite a visualizar resumo de valores repassados/recebidos',
    },
    [types_1.UsersClaims.PERMISSION_PAYMENTS]: {
        title: 'Permissão de pagamentos',
        description: 'Concede permissão para realizar pagamentos',
    },
    [types_1.UsersClaims.BACKOFFICE]: {
        title: 'Permissão de backoffice',
        description: 'Concede permissão para realizar ações backoffice',
    },
    [types_1.UsersClaims.MIGRATION_UNION_V2]: {
        title: 'Permissão para migrar para nova experiência de União',
        description: 'Concede permissão para migrar para nova experiência de União',
    },
    [types_1.UsersClaims.FEATURE_USER_AMOUNT_AGREEMENT]: {
        title: 'Aceite de valores do usuário',
        description: 'Habilita funcionalidade de aceitar/discordar/questionar valores recebidos',
    },
    [types_1.UsersClaims.FEATURE_GOALS_CONFIG]: {
        title: 'Configuração de metas',
        description: 'Habilita funcionalidade de configuração de metas dentro do fechamento',
    },
    [types_1.UsersClaims.FEATURE_SEE_OWNED_COMMISSIONS]: {
        title: 'Visualizar comissões em que sou dono',
        description: 'Habilita visualização de comissões em que o usuário é dono (mesmo quando não recebe nenhuma parte)',
    },
    [types_1.UsersClaims.CUSTOM_REPORTS]: {
        title: 'Relatórios personalizados',
        description: 'Configuração de relatórios personalizados',
    },
    [types_1.UsersClaims.ADJUSTMENT_REQUEST_VIEW]: {
        title: 'Tela de pedidos de ajustes',
        description: 'Habilita tela de pedidos de ajustes (lideres para pedir, admins para aprovar)',
    },
    [types_1.UsersClaims.SHEET_DATA_SOURCE]: {
        title: 'Google sheets como fonte de dados no fechamento',
        description: 'Habilita opção de importar Google sheets diretamente no fechamento',
    },
    [types_1.UsersClaims.FEATURE_VARIABLES]: {
        title: 'Variáveis',
        description: 'Habilita páginas de edição de variáveis (dentro do fechamento, e no menu lateral)',
    },
    [types_1.UsersClaims.UNCAPPED_RULES]: {
        title: 'Regras com porcentagem sem teto',
        description: 'Habilita o uso de regras sem teto (porcentagens maiores que 100%)',
    },
    [types_1.UsersClaims.FEATURE_TEAM_VARIABLES_VIEW]: {
        title: 'Visualizar variáveis do time',
        description: 'Habilita líderes de times a visualizar variáveis dos membros dos times (acesso via tela inicial)',
    },
    [types_1.UsersClaims.USER_MESSAGES]: {
        title: 'Mensagens aos usuários',
        description: 'Configuração de mensagens aos usuários (exibidas na tela inicial)',
    },
    [types_1.UsersClaims.TEAMS_VIEW_PERMISSION]: {
        title: 'Times que posso ver',
        description: 'Concede a permissão de visualização de usuários (e seus resultados) de times específicos',
    },
    [types_1.UsersClaims.CREDITORS_VIEW_PERMISSION]: {
        title: 'Pessoas que posso ver',
        description: 'Concede a permissão de visualização de usuários (e seus resultados) específicos',
    },
    [types_1.UsersClaims.DETAILSTABLE_HIDDEN_COLUMNS]: {
        title: 'Esconder colunas da tabela de detalhes',
        description: 'Esconde colunas específicas da tabela de detalhes (tabela padrão da página inicial)',
    },
    [types_1.UsersClaims.HIDE_DIVISION_DETAILS]: {
        title: 'Esconder detalhes de divisão',
        description: 'Esconde detalhes de divisão da página inicial (tabela default e personalizada)',
    },
    [types_1.UsersClaims.FEATURE_CREDITOR_NAME_ON_RULES]: {
        title: 'Nome do usuário nas regras',
        description: 'Habilita um autocompletar com os nomes dos usuários para preencher regras',
    },
    [types_1.UsersClaims.OFFICE_LOGO_URL]: {
        title: 'Logo da empresa',
        description: 'URL pública com uma imagem para o logo da empresa',
    },
    [types_1.UsersClaims.CREDITOR_REPORT_ROA_VIEW]: {
        title: 'Visualização de ROA nos relatórios de usuários',
        description: 'Habilita visualização de ROA nos relatórios individuais de usuários',
    },
    [types_1.UsersClaims.ALL_COMMISSIONS_TABLE]: {
        title: 'Tabela com todas as comissões',
        description: 'Habilita página com tabela de todas as comissões (detalhes de comissões e divisões)',
    },
    [types_1.UsersClaims.GROSS_COMMISSION_AMOUNT]: {
        title: 'Habilita sumarização de valores brutos',
        description: 'Habilita sumarização da coluna valores brutos na tabela da página inicial',
    },
    [types_1.UsersClaims.EXPORT_ARBITRARY_FIELDS]: {
        title: 'Exportar campos arbitrários',
        description: 'Permite visualizar campos arbitrários exportados',
    },
    [types_1.UsersClaims.USER_PREFERENCES]: {
        title: 'Preferências do usuário',
        description: 'Mantem a data, esconder valores e o estado do menu que o usuário deixou',
    },
    [types_1.UsersClaims.THEME_CONFIG]: {
        title: 'Configuração de tema',
        description: 'Configura tema (claro ou escuro) e cores gerais do sistema',
    },
    [types_1.UsersClaims.GENERIC_DATA_IMPORT]: {
        title: 'Fonte de dados',
        description: 'Habilita a página de Fonte de dados',
    },
    [types_1.UsersClaims.DOCUMENT_MANAGEMENT]: {
        title: 'Gerenciar documentos',
        description: 'Habilita página de gestão de documentos',
    },
    [types_1.UsersClaims.COMPANY_MANAGEMENT]: {
        title: 'Gerenciar empresas',
        description: 'Habilita página de gestão de empresas',
    },
    [types_1.UsersClaims.APPLY_RULES_FUTURE_CLOSURES]: {
        title: 'Aplicar regras em fechamentos futuros',
        description: 'Habilita opção de aplicar regras em fechamentos futuros (quando aplicando uma regra de fechamento)',
    },
    [types_1.UsersClaims.NOTIFY_ANSWERED_QUESTION]: {
        title: 'Notificar pergunta respondida',
        description: 'Habilita notificação quando uma pergunta é respondida (deve ser usado junto com feature.user.amount.agreement)',
    },
    [types_1.UsersClaims.NOTIFY_QUESTIONED]: {
        title: 'Notificar questionado',
        description: 'Habilita notificação quando uma nova pergunta é feita (deve ser usado junto com feature.user.amount.agreement)',
    },
    [types_1.UsersClaims.NOTIFY_PAYMENT_RECEIVED]: {
        title: 'Notificar usuário de pagamento recebido',
        description: 'Habilita notificação quando um pagamento é recebido (notifica usuário pago)',
    },
    [types_1.UsersClaims.DISABLE_SPLITC_REFERRAL]: {
        title: 'Desabilita referencia à Splitc',
        description: 'Desabilita referencia à Splitc',
    },
    [types_1.UsersClaims.OFFICE_SSO_CONFIG]: {
        title: 'Configuração de SSO da empresa',
        description: 'Configuração de SSO da empresa',
    },
    [types_1.UsersClaims.XP_INTEGRATION_CONFIG]: {
        title: 'Configuração da integração XP API',
        description: 'Configuração da integração XP API',
    },
    [types_1.UsersClaims.DISABLE_ALL_COMMISSIONS_TABLE]: {
        title: 'Desabilitar tabela com todas as comissões',
        description: 'Desabilita a tabela com todas as comissões (detalhes de comissões e divisões)',
    },
    [types_1.UsersClaims.DISABLE_HOME_MONTH_EARNING]: {
        title: 'Desabilitar ganhos na página inicial',
        description: 'Desabilitar o "olho" de ganho mensal na home',
    },
    [types_1.UsersClaims.GOAL_APPEARANCE_CONFIG]: {
        title: 'Configuração da aparência de metas',
        description: 'Configuração da aparência de metas na página inicial',
    },
    [types_1.UsersClaims.MANAGE_PERMISSION_PROFILES]: {
        title: 'Gerenciar perfis de permissão',
        description: 'Habilita tela de gestão de perfis de permissão',
    },
    [types_1.UsersClaims.MANAGE_OFFICE_PERMISSIONS]: {
        title: 'Gerenciar permissões gerais',
        description: 'Gerenciar as permissões para todos os usuários',
    },
    [types_1.UsersClaims.OFFICE_LOGIN_CONFIG]: {
        title: 'Configuração de política de login',
        description: 'Configurações usadas para forçar rotação de senha e outras configurações de login',
    },
    [types_1.UsersClaims.HIDE_REPORTS]: {
        title: 'Ocultar relatórios',
        description: 'Desabilita a visualização de relatórios',
    },
    [types_1.UsersClaims.HIDE_SPLITC_LOGO]: {
        title: 'Ocultar logo da SplitC',
        description: 'Oculta o logo da SplitC no menu',
    },
    [types_1.UsersClaims.HIDE_LOGOUT]: {
        title: 'Ocultar logout',
        description: 'Remove a opção de logout do menu',
    },
    [types_1.UsersClaims.FEATURE_DIVISION_ROUNDING]: {
        title: 'Arredondamento de divisões',
        description: 'Configuração de arredondamento das divisões',
    },
    [types_1.UsersClaims.FEATURE_INACTIVITY_LOGOUT]: {
        title: 'Logout por inatividade',
        description: 'Configuração de logout por inatividade',
    },
    [types_1.UsersClaims.STATEMENT_PANEL_VISIBLE]: {
        title: 'Habilitar o dashboard',
        description: 'Permite visualizar e interagir com o editor de dashboard',
    },
    [types_1.UsersClaims.UPSERT_CUSTOMERS_NAME]: {
        title: 'Renomear clientes',
        description: 'Permite editar o nome dos clientes',
    },
    [types_1.UsersClaims.CREDITOR_PAYMENT_INFO_VIEW]: {
        title: 'Visualizar informações de pagamento dos usuários',
        description: 'Habilita a visualização de informações de pagamento dos usuários',
    },
    [types_1.UsersClaims.CREDITOR_PAYMENT_INFO_WRITE]: {
        title: 'Gerenciar informações de pagamento dos usuários',
        description: 'Habilita o gerenciamento de informações de pagamento dos usuários',
    },
    [types_1.UsersClaims.INQUIRIES_MANAGEMENT]: {
        title: 'Gerenciar chamados dos planos de cálculos',
        description: 'Habilitar gerenciamento de chamados dos planos de cálculos',
    },
    [types_1.UsersClaims.HIDE_OLD_HOME]: {
        title: 'Esconder a antiga página inicial',
        description: 'Esconder e prevenir acesso à antiga página inicial',
    },
    [types_1.UsersClaims.ALLOW_USER_IMPERSONATION]: {
        title: 'Permitir personificar outros usuários',
        description: 'Permite o usuário de copiar acessos de usuários que ele tem permissão de ver',
    },
    [types_1.UsersClaims.PREVENT_USER_DELETION]: {
        title: 'Não permitir exclusão usuários',
        description: 'Previne que os usuários sejam excluídos',
    },
    [types_1.UsersClaims.FEATURE_PAYROLL_V2]: {
        title: 'Nova folha de pagamentos',
        description: 'Habilita nova folha de pagamentos',
    },
    [types_1.UsersClaims.CLOSURE_SHOW_HIDDEN_MESSAGE]: {
        title: 'Mensagem de fechamentos ocultos',
        description: 'Mensagem para fechamentos não liberados',
    },
    [types_1.UsersClaims.PAYROLL_STATUS_MANAGER]: {
        title: 'Gerenciador de Status da Folha de Pagamentos',
        description: 'Pode configurar o fluxo e as permissões para atualizações de status na folha de pagamentos',
    },
    [types_1.UsersClaims.USER_MANAGEMENT]: {
        title: 'Gestão de usuários',
        description: 'Pode editar usuários que possui acesso, podendo criar e/ou excluir. Incluir em times e/ou perfis',
    },
    [types_1.UsersClaims.AUTOMATIC_BACKUP_CLOSURES]: {
        title: 'Backup Automático dos fechamentos',
        description: 'Habilita backup automático dos fechamentos após alterações(aplicar regras, troca de campos)',
    },
    [types_1.UsersClaims.PLAN_GROUP_PERMISSIONS]: {
        title: 'Permissões granulares de planos de cálculos',
        description: 'Permite a configuração de permissões granulares para planos de cálculos específicos',
    },
    [types_1.UsersClaims.REQUIRED_INQUIRY_TAG]: {
        title: 'Categorização de chamados obrigatória',
        description: 'Torna a seleção de uma categoria obrigatória para criar um chamado',
    },
    [types_1.UsersClaims.FEATURE_PAYROLL_REQUESTS]: {
        title: 'Pedidos de pagamento',
        description: 'Habilita a abertura de pedidos de pagamento',
    },
    [types_1.UsersClaims.PAYROLL_NOTIFICATION]: {
        title: 'Notificação de Pagamento',
        description: 'Habilita a notificação de usuários na folha de pagamento.',
    },
    [types_1.UsersClaims.LANGUAGE_PREFERENCE]: {
        title: 'Linguagem do Sistema',
        description: 'Define qual a linguagem do sistema.',
    },
    [types_1.UsersClaims.EXPORT_CREDITOR_TEAMS_FIELD]: {
        title: 'Exportar campo de times dos usuários',
        description: 'Permite exportar o campo de times dos usuários na listagem de comissões',
    },
    [types_1.UsersClaims.POLICY_AGREEMENT_MANAGER]: {
        title: 'Gerente de políticas de aceite',
        description: 'Habilita o gerenciamento das políticas de aceite',
    },
    [types_1.UsersClaims.POLICY_AGREEMENT_MODULE]: {
        title: 'Módulo de políticas de aceite',
        description: 'Habilita o modulo de políticas de aceite',
    },
    [types_1.UsersClaims.ALLOW_CREDENTIALS_MANAGEMENT]: {
        title: 'Permitir gerenciamento de credenciais do usuário',
        description: 'Concede aos administradores a capacidade de gerar ou resetar o nome de usuário e senha para o usuário.',
    },
};
const es = {
    [types_1.UsersClaims.OFFICE_CREDITORS_VIEW]: {
        title: 'Ver resultado de todos los usuarios',
        description: 'Permite la visualización de todos los usuarios en la empresa',
    },
    [types_1.UsersClaims.CUSTOMIZED_TABLE]: {
        title: 'Tabla personalizada en la página de inicio',
        description: 'Muestra una tabla personalizada en la página de inicio en lugar de la tabla predeterminada',
    },
    [types_1.UsersClaims.TEAM_CREDITORS_VIEW]: {
        title: 'Ver usuarios del equipo',
        description: 'Permite la visualización de usuarios de los propios equipos',
    },
    [types_1.UsersClaims.CLOSURE_UNFINISHED_VIEW]: {
        title: 'Ver cierres inacabados',
        description: 'Permite visualizar los cierres inacabados',
    },
    [types_1.UsersClaims.CLOSURE_UPDATE]: {
        title: 'Actualizar cierres',
        description: 'Permite actualizar/ver cierres',
    },
    [types_1.UsersClaims.USER_CREATE]: {
        title: 'Crear usuarios',
        description: 'Permite la creación de usuarios',
    },
    [types_1.UsersClaims.PAYROLL_VIEW]: {
        title: 'Ver nómina',
        description: 'Permite la visualización de la nómina',
    },
    [types_1.UsersClaims.PAYSLIP_VIEW]: {
        title: 'Ver resumen de valores transferidos/recibidos',
        description: 'Permite ver el resumen de valores transferidos/recibidos',
    },
    [types_1.UsersClaims.PERMISSION_PAYMENTS]: {
        title: 'Permiso de pagos',
        description: 'Otorga permiso para realizar pagos',
    },
    [types_1.UsersClaims.BACKOFFICE]: {
        title: 'Permiso de backoffice',
        description: 'Otorga permiso para realizar acciones de backoffice',
    },
    [types_1.UsersClaims.MIGRATION_UNION_V2]: {
        title: 'Permiso para migrar a la nueva experiencia de Unión',
        description: 'Otorga permiso para migrar a la nueva experiencia de Unión',
    },
    [types_1.UsersClaims.FEATURE_USER_AMOUNT_AGREEMENT]: {
        title: 'Aceptación de valores del usuario',
        description: 'Habilita la funcionalidad de aceptar/discrepar/cuestión valores recibidos',
    },
    [types_1.UsersClaims.FEATURE_GOALS_CONFIG]: {
        title: 'Configuración de objetivos',
        description: 'Habilita la funcionalidad de configuración de objetivos dentro del cierre',
    },
    [types_1.UsersClaims.FEATURE_SEE_OWNED_COMMISSIONS]: {
        title: 'Ver comisiones en las que soy dueño',
        description: 'Habilita la visualización de comisiones en las que el usuario es dueño (incluso si no recibe ninguna parte)',
    },
    [types_1.UsersClaims.CUSTOM_REPORTS]: {
        title: 'Informes personalizados',
        description: 'Configuración de informes personalizados',
    },
    [types_1.UsersClaims.ADJUSTMENT_REQUEST_VIEW]: {
        title: 'Pantalla de solicitudes de ajustes',
        description: 'Habilita pantalla de solicitudes de ajustes (líderes para solicitar, admins para aprobar)',
    },
    [types_1.UsersClaims.SHEET_DATA_SOURCE]: {
        title: 'Google Sheets como fuente de datos en el cierre',
        description: 'Habilita la opción de importar Google Sheets directamente en el cierre',
    },
    [types_1.UsersClaims.FEATURE_VARIABLES]: {
        title: 'Variables',
        description: 'Habilita páginas de edición de variables (dentro del cierre y en el menú lateral)',
    },
    [types_1.UsersClaims.UNCAPPED_RULES]: {
        title: 'Reglas con porcentaje sin límite',
        description: 'Habilita el uso de reglas sin límite (porcentajes mayores al 100%)',
    },
    [types_1.UsersClaims.FEATURE_TEAM_VARIABLES_VIEW]: {
        title: 'Ver variables del equipo',
        description: 'Habilita a los líderes de equipos a ver variables de los miembros del equipo (acceso desde la pantalla de inicio)',
    },
    [types_1.UsersClaims.USER_MESSAGES]: {
        title: 'Mensajes a los usuarios',
        description: 'Configuración de mensajes a los usuarios (mostrados en la pantalla de inicio)',
    },
    [types_1.UsersClaims.TEAMS_VIEW_PERMISSION]: {
        title: 'Equipos que puedo ver',
        description: 'Otorga permiso para ver usuarios (y sus resultados) de equipos específicos',
    },
    [types_1.UsersClaims.CREDITORS_VIEW_PERMISSION]: {
        title: 'Personas que puedo ver',
        description: 'Otorga permiso para ver usuarios (y sus resultados) específicos',
    },
    [types_1.UsersClaims.DETAILSTABLE_HIDDEN_COLUMNS]: {
        title: 'Ocultar columnas de la tabla de detalles',
        description: 'Oculta columnas específicas de la tabla de detalles (tabla predeterminada en la página de inicio)',
    },
    [types_1.UsersClaims.HIDE_DIVISION_DETAILS]: {
        title: 'Ocultar detalles de división',
        description: 'Oculta detalles de división de la página de inicio (tabla predeterminada y personalizada)',
    },
    [types_1.UsersClaims.FEATURE_CREDITOR_NAME_ON_RULES]: {
        title: 'Nombre del usuario en las reglas',
        description: 'Habilita autocompletar con los nombres de los usuarios para completar reglas',
    },
    [types_1.UsersClaims.OFFICE_LOGO_URL]: {
        title: 'Logotipo de la empresa',
        description: 'URL pública con una imagen para el logotipo de la empresa',
    },
    [types_1.UsersClaims.CREDITOR_REPORT_ROA_VIEW]: {
        title: 'Vista de ROA en los informes de usuarios',
        description: 'Habilita la visualización de ROA en los informes individuales de usuarios',
    },
    [types_1.UsersClaims.ALL_COMMISSIONS_TABLE]: {
        title: 'Tabla con todas las comisiones',
        description: 'Habilita una página con tabla de todas las comisiones (detalles de comisiones y divisiones)',
    },
    [types_1.UsersClaims.GROSS_COMMISSION_AMOUNT]: {
        title: 'Habilita la suma de valores brutos',
        description: 'Habilita la suma de la columna de valores brutos en la tabla de la página de inicio',
    },
    [types_1.UsersClaims.EXPORT_ARBITRARY_FIELDS]: {
        title: 'Exportar campos arbitrarios',
        description: 'Permite ver campos arbitrarios exportados',
    },
    [types_1.UsersClaims.USER_PREFERENCES]: {
        title: 'Preferencias del usuario',
        description: 'Mantiene la fecha, ocultar valores y el estado del menú que dejó el usuario',
    },
    [types_1.UsersClaims.THEME_CONFIG]: {
        title: 'Configuración de tema',
        description: 'Configura el tema (claro u oscuro) y colores generales del sistema',
    },
    [types_1.UsersClaims.GENERIC_DATA_IMPORT]: {
        title: 'Fuente de datos',
        description: 'Habilita la página de Fuente de datos',
    },
    [types_1.UsersClaims.DOCUMENT_MANAGEMENT]: {
        title: 'Gestión de documentos',
        description: 'Habilita la página de gestión de documentos',
    },
    [types_1.UsersClaims.COMPANY_MANAGEMENT]: {
        title: 'Gestión de empresas',
        description: 'Habilita la página de gestión de empresas',
    },
    [types_1.UsersClaims.APPLY_RULES_FUTURE_CLOSURES]: {
        title: 'Aplicar reglas en cierres futuros',
        description: 'Habilita la opción de aplicar reglas en cierres futuros (al aplicar una regla de cierre)',
    },
    [types_1.UsersClaims.NOTIFY_ANSWERED_QUESTION]: {
        title: 'Notificar pregunta respondida',
        description: 'Habilita la notificación cuando una pregunta es respondida (debe usarse junto con feature.user.amount.agreement)',
    },
    [types_1.UsersClaims.NOTIFY_QUESTIONED]: {
        title: 'Notificar cuestionado',
        description: 'Habilita la notificación cuando se realiza una nueva pregunta (debe usarse junto con feature.user.amount.agreement)',
    },
    [types_1.UsersClaims.NOTIFY_PAYMENT_RECEIVED]: {
        title: 'Notificar usuario de pago recibido',
        description: 'Habilita la notificación cuando se recibe un pago (notifica al usuario que pagó)',
    },
    [types_1.UsersClaims.DISABLE_SPLITC_REFERRAL]: {
        title: 'Desactivar referencia a Splitc',
        description: 'Desactiva la referencia a Splitc',
    },
    [types_1.UsersClaims.OFFICE_SSO_CONFIG]: {
        title: 'Configuración de SSO de la empresa',
        description: 'Configuración de SSO de la empresa',
    },
    [types_1.UsersClaims.XP_INTEGRATION_CONFIG]: {
        title: 'Configuración de integración XP API',
        description: 'Configuración de integración XP API',
    },
    [types_1.UsersClaims.DISABLE_ALL_COMMISSIONS_TABLE]: {
        title: 'Desactivar tabla con todas las comisiones',
        description: 'Desactiva la tabla con todas las comisiones (detalles de comisiones y divisiones)',
    },
    [types_1.UsersClaims.DISABLE_HOME_MONTH_EARNING]: {
        title: 'Desactivar ganancias en la página de inicio',
        description: 'Desactivar el "ojo" de ganancia mensual en la página de inicio',
    },
    [types_1.UsersClaims.GOAL_APPEARANCE_CONFIG]: {
        title: 'Configuración de la apariencia de metas',
        description: 'Configuración de la apariencia de metas en la página de inicio',
    },
    [types_1.UsersClaims.MANAGE_PERMISSION_PROFILES]: {
        title: 'Gestionar perfiles de permiso',
        description: 'Habilita la pantalla de gestión de perfiles de permiso',
    },
    [types_1.UsersClaims.MANAGE_OFFICE_PERMISSIONS]: {
        title: 'Gestionar permisos generales',
        description: 'Gestionar los permisos para todos los usuarios',
    },
    [types_1.UsersClaims.OFFICE_LOGIN_CONFIG]: {
        title: 'Configuración de la política de inicio de sesión',
        description: 'Configuraciones utilizadas para forzar rotación de contraseña y otras configuraciones de inicio de sesión',
    },
    [types_1.UsersClaims.HIDE_REPORTS]: {
        title: 'Ocultar informes',
        description: 'Desactiva la visualización de informes',
    },
    [types_1.UsersClaims.HIDE_SPLITC_LOGO]: {
        title: 'Ocultar logo de SplitC',
        description: 'Oculta el logo de SplitC en el menú',
    },
    [types_1.UsersClaims.HIDE_LOGOUT]: {
        title: 'Ocultar cerrar sesión',
        description: 'Elimina la opción de cerrar sesión del menú',
    },
    [types_1.UsersClaims.FEATURE_DIVISION_ROUNDING]: {
        title: 'Redondeo de divisiones',
        description: 'Configuración de redondeo de las divisiones',
    },
    [types_1.UsersClaims.FEATURE_INACTIVITY_LOGOUT]: {
        title: 'Cierre de sesión por inactividad',
        description: 'Configuración de cierre de sesión por inactividad',
    },
    [types_1.UsersClaims.STATEMENT_PANEL_VISIBLE]: {
        title: 'Habilitar el tablero',
        description: 'Permite visualizar e interactuar con el editor de tablero',
    },
    [types_1.UsersClaims.UPSERT_CUSTOMERS_NAME]: {
        title: 'Renombrar clientes',
        description: 'Permite editar el nombre de los clientes',
    },
    [types_1.UsersClaims.CREDITOR_PAYMENT_INFO_VIEW]: {
        title: 'Ver información de pago de los usuarios',
        description: 'Habilita la visualización de información de pago de los usuarios',
    },
    [types_1.UsersClaims.CREDITOR_PAYMENT_INFO_WRITE]: {
        title: 'Gestionar información de pago de los usuarios',
        description: 'Habilita la gestión de información de pago de los usuarios',
    },
    [types_1.UsersClaims.INQUIRIES_MANAGEMENT]: {
        title: 'Gestionar solicitudes de los planes de cálculos',
        description: 'Habilita la gestión de solicitudes de los planes de cálculos',
    },
    [types_1.UsersClaims.HIDE_OLD_HOME]: {
        title: 'Ocultar la antigua página de inicio',
        description: 'Ocultar y prevenir el acceso a la antigua página de inicio',
    },
    [types_1.UsersClaims.ALLOW_USER_IMPERSONATION]: {
        title: 'Permitir personificación de otros usuarios',
        description: 'Permite al usuario copiar accesos de usuarios que tiene permiso de ver',
    },
    [types_1.UsersClaims.PREVENT_USER_DELETION]: {
        title: 'No permitir eliminación de usuarios',
        description: 'Impide que los usuarios sean eliminados',
    },
    [types_1.UsersClaims.FEATURE_PAYROLL_V2]: {
        title: 'Nueva nómina',
        description: 'Habilita la nueva nómina',
    },
    [types_1.UsersClaims.CLOSURE_SHOW_HIDDEN_MESSAGE]: {
        title: 'Mensaje de cierres ocultos',
        description: 'Mensaje para cierres no liberados',
    },
    [types_1.UsersClaims.PAYROLL_STATUS_MANAGER]: {
        title: 'Gestor de Estado de Nómina',
        description: 'Puede configurar el flujo y los permisos para actualizaciones de estado en la nómina',
    },
    [types_1.UsersClaims.USER_MANAGEMENT]: {
        title: 'Gestión de usuarios',
        description: 'Puede editar usuarios que tiene acceso, pudiendo crear y/o eliminar. Incluir en equipos y/o perfiles',
    },
    [types_1.UsersClaims.AUTOMATIC_BACKUP_CLOSURES]: {
        title: 'Backup Automático de los cierres',
        description: 'Habilita backup automático de los cierres después de cambios (aplicar reglas, cambio de campos)',
    },
    [types_1.UsersClaims.PLAN_GROUP_PERMISSIONS]: {
        title: 'Permisos granulares de planes de cálculos',
        description: 'Permite la configuración de permisos granulares para planes de cálculos específicos',
    },
    [types_1.UsersClaims.REQUIRED_INQUIRY_TAG]: {
        title: 'Categorización obligatoria de solicitudes',
        description: 'Hace obligatorio seleccionar una categoría para crear una solicitud',
    },
    [types_1.UsersClaims.FEATURE_PAYROLL_REQUESTS]: {
        title: 'Solicitudes de pago',
        description: 'Habilita la apertura de solicitudes de pago',
    },
    [types_1.UsersClaims.PAYROLL_NOTIFICATION]: {
        title: 'Notificación de Pago',
        description: 'Habilita la notificación de usuarios en la nómina',
    },
    [types_1.UsersClaims.LANGUAGE_PREFERENCE]: {
        title: 'Idioma del Sistema',
        description: 'Define el idioma del sistema',
    },
    [types_1.UsersClaims.EXPORT_CREDITOR_TEAMS_FIELD]: {
        title: 'Exportar campo de equipos de los usuarios',
        description: 'Permite exportar el campo de equipos de los usuarios en la lista de comisiones',
    },
    [types_1.UsersClaims.POLICY_AGREEMENT_MANAGER]: {
        title: 'Gerente de políticas de aceptación',
        description: 'Habilita la gestión de las políticas de aceptación',
    },
    [types_1.UsersClaims.POLICY_AGREEMENT_MODULE]: {
        title: 'Módulo de políticas de aceptación',
        description: 'Habilita el módulo de políticas de aceptación',
    },
    [types_1.UsersClaims.ALLOW_CREDENTIALS_MANAGEMENT]: {
        title: 'Permitir gestión de credenciales del usuario',
        description: 'Otorga a los administradores la capacidad de generar o restablecer el nombre de usuario y la contraseña del usuario.',
    },
};
const claimLanguageMap = {
    'pt-BR': ptBR,
    es: es,
};
function mergeClaimMapWithTranslation(translationsObj) {
    const newClaimMap = {};
    Object.entries(__1.claimMap).forEach(([key, value]) => {
        const typedKey = key;
        if (translationsObj[typedKey]) {
            newClaimMap[typedKey] = {
                ...value,
                ...translationsObj[typedKey],
            };
            return;
        }
        newClaimMap[typedKey] = value;
    });
    return newClaimMap;
}
function getTranslatedClaims(locale = 'pt-BR') {
    const existClaimLanguageMap = claimLanguageMap[locale];
    if (!existClaimLanguageMap) {
        return __1.claimMap;
    }
    const claimTranslate = mergeClaimMapWithTranslation(existClaimLanguageMap);
    return claimTranslate;
}
exports.getTranslatedClaims = getTranslatedClaims;
